import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { uploadImage, imgUrl } from "@/lib/api";
import { toast } from "sonner";

export function ImageUploader({ value, onChange, label = "Image", testId = "image" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const url = await uploadImage(file);
      onChange(url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-2">
      <span className="text-xs font-mono uppercase tracking-widest text-zinc-400">{label}</span>
      <div className="flex items-center gap-3">
        <div className="w-16 h-16 border border-white/15 bg-black shrink-0 overflow-hidden flex items-center justify-center">
          {value ? (
            <img src={imgUrl(value)} alt="" className="w-full h-full object-cover" />
          ) : (
            <span className="text-[10px] text-zinc-600 font-mono">EMPTY</span>
          )}
        </div>
        <button
          type="button"
          data-testid={`upload-${testId}-btn`}
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          className="flex items-center gap-2 px-4 py-2 border border-white/15 hover:border-[#FF3B30] hover:text-[#FF3B30] transition-colors text-xs font-mono uppercase tracking-wider disabled:opacity-50"
        >
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
          {busy ? "Uploading" : "Upload"}
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" data-testid={`file-input-${testId}`} />
    </div>
  );
}
